// FitClutch — funil web — textos em português (Brasil)
export default {
  'ageSelect.titleLine1': 'Monte o seu',
  'ageSelect.titleHighlight': 'Plano de Treino Personalizado',
  'ageSelect.poweredBy': 'Com inteligência artificial do FitClutch',
  'ageSelect.subtitle': 'Escolha sua faixa de idade para começar',
  'ageSelect.duration': 'Quiz de 3 minutos',
  'ageSelect.ageLabel': 'Idade: {range}',
  'ageSelect.footnote': 'Ao continuar, você concorda com nossos {terms} e {privacy}.',
  'ageSelect.termsLink': 'Termos de Uso',
  'ageSelect.privacyLink': 'Política de Privacidade',

  'gender.title': 'Qual é o seu gênero?',
  'gender.subtitle': 'Usamos isso só pra personalizar o seu plano',
  'gender.male': 'Masculino',
  'gender.female': 'Feminino',
  'gender.other': 'Prefiro não dizer',

  'socialProof.genderWomen': 'mulheres',
  'socialProof.genderMen': 'homens',
  'socialProof.genderPeople': 'pessoas',
  'socialProof.decade20': 'na casa dos 20',
  'socialProof.decade30': 'na casa dos 30',
  'socialProof.decade40': 'na casa dos 40',
  'socialProof.decade50': 'na casa dos 50 ou mais',
  'socialProof.headlineBig': 'Mais de {users} {gender}',
  'socialProof.subcopy': '{decade} já confiam no FitClutch para <hl>alcançar seus objetivos, no nível de condicionamento certo e com o equipamento que você tem disponível</hl>. Se adaptando conforme você evolui.',
  'socialProof.subcopyNoDecade': 'já confiam no FitClutch para <hl>alcançar seus objetivos, no nível de condicionamento certo e com o equipamento que você tem disponível</hl>. Se adaptando conforme você evolui.',
  'socialProof.downloadsLabel': 'Downloads',
  'socialProof.cta': 'Continuar',

  'goal.question': 'Qual é o seu principal objetivo com o treino?',
  'goal.option_hipertrofia': 'Ganhar músculo',
  'goal.option_emagrecer': 'Perder peso',
  'goal.option_forca': 'Ficar mais forte',
  'goal.option_condicionamento': 'Melhorar o condicionamento geral',
  'goal.feedbackLead': 'Perfeito:',
  'goal.feedback_hipertrofia': 'treinos de força personalizados com forma guiada em vídeo pra cada repetição.',
  'goal.feedback_emagrecer': 'um plano de treino pensado pra manter seu metabolismo acelerado.',
  'goal.feedback_forca': 'progressão de carga segura pra você ficar mais forte de verdade.',
  'goal.feedback_condicionamento': 'sessões equilibradas pra melhorar resistência, mobilidade e energia.',

  'bodyShape.question': 'Qual descreve melhor o seu corpo hoje?',
  'bodyShape.option_magro_male': 'Magro',
  'bodyShape.option_magro_female': 'Magra',
  'bodyShape.option_magro_neutral': 'Corpo magro',
  'bodyShape.option_cheio_male': 'Mais cheio',
  'bodyShape.option_cheio_female': 'Mais cheia',
  'bodyShape.option_cheio_neutral': 'Corpo mais cheio',
  'bodyShape.option_atletico_male': 'Atlético',
  'bodyShape.option_atletico_female': 'Atlética',
  'bodyShape.option_atletico_neutral': 'Corpo atlético',
  'bodyShape.option_definido_male': 'Definido',
  'bodyShape.option_definido_female': 'Definida',
  'bodyShape.option_definido_neutral': 'Corpo definido',
  'bodyShape.option_medio_male': 'Médio',
  'bodyShape.option_medio_female': 'Média',
  'bodyShape.option_medio_neutral': 'Corpo médio',

  'bodyGoal.question': 'Qual corpo você quer conquistar?',
  'bodyGoal.option_definido_male': 'Definido e tonificado',
  'bodyGoal.option_definido_female': 'Definida e tonificada',
  'bodyGoal.option_definido_neutral': 'Corpo definido e tonificado',
  'bodyGoal.option_atletico_male': 'Atlético e musculoso',
  'bodyGoal.option_atletico_female': 'Atlética e sarada',
  'bodyGoal.option_atletico_neutral': 'Corpo atlético e musculoso',
  'bodyGoal.option_magro_male': 'Magro e leve',
  'bodyGoal.option_magro_female': 'Magra e leve',
  'bodyGoal.option_magro_neutral': 'Corpo magro e leve',
  'bodyGoal.option_curvilineo_male': 'Forte e volumoso',
  'bodyGoal.option_curvilineo_female': 'Forte e com curvas',
  'bodyGoal.option_curvilineo_neutral': 'Corpo forte e definido',

  'lastBest.question': 'Quando foi a última vez que você esteve na sua melhor forma física?',
  'lastBest.option_agora': 'Agora mesmo',
  'lastBest.option_menos_1_ano': 'Menos de um ano atrás',
  'lastBest.option_1_3_anos': 'Entre 1 e 3 anos atrás',
  'lastBest.option_mais_3_anos': 'Mais de 3 anos atrás',
  'lastBest.option_nunca': 'Nunca',

  'weightTrend.question': 'Como o seu peso costuma variar?',
  'weightTrend.option_estavel': 'Bem estável',
  'weightTrend.option_varia': 'Varia conforme meus hábitos',
  'weightTrend.option_subindo': 'Vem subindo aos poucos',
  'weightTrend.option_caindo': 'Vem caindo aos poucos',
  'weightTrend.option_nao_sei': 'Não tenho certeza',

  'transformPromo.headline': 'Seu objetivo: {target}. Vamos te mostrar exatamente como chegar lá.',
  'transformPromo.subcopyLead': 'Treine sem medo de se machucar. O FitClutch tem',
  'transformPromo.subcopyHighlight1': 'vídeos demonstrativos',
  'transformPromo.subcopyMid': 'pra cada exercício, te ajudando a acertar a execução e',
  'transformPromo.subcopyHighlight2': 'evitar lesões',
  'transformPromo.cta': 'Continuar',

  'pushUps.question': 'Qual é o máximo de flexões que você consegue fazer de uma vez?',
  'pushUps.option_nenhuma': 'Nenhuma ainda',
  'pushUps.option_1_5': '1 a 5',
  'pushUps.option_6_15': '6 a 15',
  'pushUps.option_16_30': '16 a 30',
  'pushUps.option_30_mais': 'Mais de 30',

  'squats.question': 'Quantos agachamentos seguidos você aguenta fazer?',
  'squats.option_nenhuma': 'Nenhum ainda',
  'squats.option_1_10': '1 a 10',
  'squats.option_11_25': '11 a 25',
  'squats.option_26_50': '26 a 50',
  'squats.option_50_mais': 'Mais de 50',

  'flexibility.question': 'Qual é o seu nível de flexibilidade?',
  'flexibility.option_nao_alcanco': 'Não consigo alcançar os pés',
  'flexibility.option_quase': 'Quase alcanço os pés',
  'flexibility.option_facil': 'Alcanço os pés sem esforço',
  'flexibility.option_muito_flexivel': 'Muito flexível (espacate, alongamentos profundos)',
  'flexibility.option_nao_sei': 'Não sei dizer',

  'progressPromo.headline': 'Seu ponto de partida está definido. Agora vamos ver ele se mover.',
  'progressPromo.subcopyLead': 'Cada treino é',
  'progressPromo.subcopyHighlight': 'registrado automaticamente',
  'progressPromo.subcopyTail': '— estatísticas em tempo real pra te manter motivado.',
  'progressPromo.cta': 'Continuar',

  'focusArea.question': 'Quais são as suas zonas de foco?',
  'focusArea.subtitle': 'Escolha uma região específica ou "Corpo inteiro".',
  'focusArea.option_superior': 'Parte superior',
  'focusArea.option_core': 'Core / Abdômen',
  'focusArea.option_inferior': 'Parte inferior',
  'focusArea.option_corpo_inteiro': 'Corpo inteiro',
  'focusArea.cta': 'Continuar',

  'injuries.question': 'Alguma área pede mais cuidado no treino?',
  'injuries.subtitle': 'Vamos adaptar seus exercícios para proteger essas regiões.',
  'injuries.option_ombros': 'Ombros',
  'injuries.option_joelhos': 'Joelhos',
  'injuries.option_costas': 'Costas',
  'injuries.option_nenhuma': 'Nenhuma',
  'injuries.disclaimer': 'Ajustes preventivos — não substituem avaliação médica.',
  'injuries.cta': 'Continuar',

  'workoutDuration.question': 'Qual é o tempo ideal de treino pra você?',
  'workoutDuration.option_rapido': 'Rápido',
  'workoutDuration.option_rapido_subtitle': '3 exercícios',
  'workoutDuration.option_rapido_badge': 'Até 20 min',
  'workoutDuration.option_curto': 'Curto',
  'workoutDuration.option_curto_subtitle': '4-6 exercícios',
  'workoutDuration.option_curto_badge': '20-40 min',
  'workoutDuration.option_medio': 'Médio',
  'workoutDuration.option_medio_subtitle': '5-7 exercícios',
  'workoutDuration.option_medio_badge': '40-60 min',
  'workoutDuration.option_longo': 'Longo',
  'workoutDuration.option_longo_subtitle': '8-10 exercícios',
  'workoutDuration.option_longo_badge': '60+ min',

  'trainingSummaryPromo.headline': '{days}, sessões de {duration} — já estão a caminho.',
  'trainingSummaryPromo.subcopyLead': 'Direto da nossa',
  'trainingSummaryPromo.subcopyHighlight': 'biblioteca de treinos',
  'trainingSummaryPromo.subcopyTail': ', sempre tem um pronto pra você.',
  'trainingSummaryPromo.cta': 'Continuar',
  'trainingSummaryPromo.days_2': '1-2x por semana',
  'trainingSummaryPromo.days_4': '3-4x por semana',
  'trainingSummaryPromo.days_6': '5-6x por semana',
  'trainingSummaryPromo.days_7': 'Todo dia',

  'workSchedule.question': 'Como é a sua rotina de trabalho?',
  'workSchedule.option_fixo': 'Horário comercial',
  'workSchedule.option_noturno': 'Turno da noite',
  'workSchedule.option_flexivel': 'Horário flexível',
  'workSchedule.option_parado': 'Não estou trabalhando',

  'dailyActivity.question': 'Como é o seu dia a dia fora do treino?',
  'dailyActivity.option_sentado': 'Principalmente sentado',
  'dailyActivity.option_ativo': 'Em pé ou me movendo',
  'dailyActivity.option_misto': 'Um pouco dos dois',
  'dailyActivity.option_nao_sei': 'Não sei dizer',

  'sleepHours.question': 'Quantas horas você costuma dormir?',
  'sleepHours.option_menos_5': 'Menos de 5 horas',
  'sleepHours.option_5_6': '5-6 horas',
  'sleepHours.option_7_8': '7-8 horas',
  'sleepHours.option_mais_8': 'Mais de 8 horas',

  'waterIntake.question': 'Quantos copos de água você bebe por dia?',
  'waterIntake.subtitle': 'Toque no número que mais se aproxima da sua rotina.',
  'waterIntake.cta': 'Continuar',

  'profileSummary.headline': 'Aqui está o seu perfil',
  'profileSummary.imcLabel': 'IMC - {imc}',
  'profileSummary.imcAbaixo': 'Abaixo',
  'profileSummary.imcNormal': 'Normal',
  'profileSummary.imcAcima': 'Acima',
  'profileSummary.imcObeso': 'Obeso',
  'profileSummary.bodyTypeLabel': 'Tipo de corpo',
  'profileSummary.bodyType_ectomorfo': 'Ectomorfo',
  'profileSummary.bodyType_mesomorfo': 'Mesomorfo',
  'profileSummary.bodyType_endomorfo': 'Endomorfo',
  'profileSummary.lifestyleLabel': 'Estilo de vida',
  'profileSummary.lifestyle_sedentario': 'Sedentário',
  'profileSummary.lifestyle_ativo': 'Ativo',
  'profileSummary.lifestyle_equilibrado': 'Equilibrado',
  'profileSummary.conditioningLabel': 'Nível de condicionamento',
  'profileSummary.conditioning_iniciante': 'Básico',
  'profileSummary.conditioning_intermediario': 'Intermediário',
  'profileSummary.conditioning_avancado': 'Avançado',
  'profileSummary.conditioning_especialista': 'Especialista',
  'profileSummary.metabolismLabel': 'Metabolismo',
  'profileSummary.metabolism_lento': 'Lento, ganha peso fácil',
  'profileSummary.metabolism_acelerado': 'Acelerado, perde peso fácil',
  'profileSummary.metabolism_equilibrado': 'Equilibrado',
  'profileSummary.metabolism_variavel': 'Variável, depende dos hábitos',
  'profileSummary.cta': 'Continuar',

  'barriers.question': 'O que te impediu de entrar em forma antes?',
  'barriers.option_motivacao': 'Falta de motivação',
  'barriers.option_sem_plano': 'Sem um plano estruturado',
  'barriers.option_tempo': 'Falta de tempo',
  'barriers.option_lesoes': 'Lesões físicas',
  'barriers.option_outro': 'Outros motivos',

  'consistencyChart.headline': 'O FitClutch te ajuda a manter a consistência!',
  'consistencyChart.subcopyLead': 'Seu plano personalizado traz tudo que você precisa pra',
  'consistencyChart.subcopyHighlight1': 'manter a motivação lá em cima',
  'consistencyChart.subcopyMid': 'e',
  'consistencyChart.subcopyHighlight2': 'alcançar o corpo que você quer',
  'consistencyChart.chartTitle': 'Sua evolução',
  'consistencyChart.nowLabel': 'Agora',
  'consistencyChart.withLabel': 'Com FitClutch',
  'consistencyChart.withoutLabel': 'Sem FitClutch',
  'consistencyChart.disclaimer': 'Aviso: os exemplos são ilustrativos. Manter a consistência nos treinos e na alimentação é o que realmente leva ao resultado.',
  'consistencyChart.cta': 'Continuar',

  'progressLoader.headline': 'Criando o seu Plano de Treino Pessoal',
  'progressLoader.item_bodyType': 'Ajustando ao seu tipo de corpo e rotina',
  'progressLoader.item_fitnessLevel': 'Avaliando seu nível de condicionamento',
  'progressLoader.item_plan': 'Montando seu plano personalizado',
  'progressLoader.testimonial1_title': 'Mudou minha rotina',
  'progressLoader.testimonial1_body': 'Finalmente um plano que se encaixa na minha semana de verdade. Simples de seguir e os treinos fazem sentido.',
  'progressLoader.testimonial1_author': 'Renata A.',
  'progressLoader.testimonial2_title': 'Resultados reais',
  'progressLoader.testimonial2_body': 'Em poucas semanas já senti diferença na disposição e na força. O plano se ajusta comigo, não o contrário.',
  'progressLoader.testimonial2_author': 'Juliana M.',
  'progressLoader.testimonial3_title': 'Treino que eu sigo de verdade',
  'progressLoader.testimonial3_body': 'Nunca consegui manter uma rotina até usar o FitClutch. Agora virou parte do meu dia.',
  'progressLoader.testimonial3_author': 'Carla S.',
  'progressLoader.testimonial4_title': 'Vale muito a pena',
  'progressLoader.testimonial4_body': 'Simples, direto ao ponto e totalmente pensado pro meu corpo e pra minha rotina.',
  'progressLoader.testimonial4_author': 'Fernanda O.',

  'emailCapture.headlineLead': 'Digite seu e-mail para receber seu',
  'emailCapture.headlineHighlight': 'Plano de Treino Personalizado',
  'emailCapture.placeholder': 'seuemail@exemplo.com',
  'emailCapture.cta': 'Continuar',
  'emailCapture.privacyLead': 'Respeitamos sua privacidade e protegemos seus dados pessoais, de acordo com a nossa',
  'emailCapture.privacyLink': 'Política de Privacidade',

  'discountReveal.headline': 'Separamos uma surpresa pra você',
  'discountReveal.subtitle': 'Para comemorar esse primeiro passo, preparamos um presente especial',
  'discountReveal.cardTitle': 'Cupom Surpresa',
  'discountReveal.tapToReveal': 'Toque para abrir',
  'discountReveal.badgeValue': '50%',
  'discountReveal.badgeSubtitle': 'de desconto no seu primeiro plano',
  'discountReveal.codeLabel': 'Cupom de boas-vindas',
  'discountReveal.codeValue': 'FITCLUTCH50',
  'discountReveal.appliedNote': 'Aplicado automaticamente no seu checkout.',
  'discountReveal.redirecting': 'Redirecionando em {seconds}s...',

  // ------------------------------------------------------------------------
  // Paywall de rolagem longa (BR também, a partir de 02/10/2026 — pedido da
  // Gladis: "tira fora as telas de pagamento que estão ali no Brasil, não
  // vamos usar essas, vamos usar a nova"). O card de preço único do plano
  // semanal usa esse mesmo texto, só que com o plano real do Stripe.
  'paywallIntl.offerReserved': 'Oferta reservada por:',
  'paywallIntl.getPlan': 'Ver meu plano',
  'paywallIntl.planReadyLead': 'Seu',
  'paywallIntl.planReadyHighlight': 'Plano de Treino Personalizado',
  'paywallIntl.planReadyTail': 'está pronto',
  'paywallIntl.dayLabel': 'Dia {n}',
  'paywallIntl.statWorkouts': 'Treinos/semana',
  'paywallIntl.statDuration': 'Minutos',
  'paywallIntl.statCalories': 'Calorias',
  'paywallIntl.muscle_chest': 'Peito',
  'paywallIntl.muscle_back': 'Costas',
  'paywallIntl.muscle_legs': 'Pernas',
  'paywallIntl.muscle_shoulders': 'Ombros',
  'paywallIntl.muscle_triceps': 'Tríceps',
  'paywallIntl.muscle_biceps': 'Bíceps',
  'paywallIntl.muscle_abs': 'Abdômen',
  'paywallIntl.muscle_glutes': 'Glúteos',
  'paywallIntl.muscle_forearms': 'Antebraços',
  'paywallIntl.weeklyPlanName': 'Plano Semanal',
  'paywallIntl.perWeek': 'por semana',
  'paywallIntl.benefitsTitle': 'O que você ganha com',
  'paywallIntl.benefit1': 'Plano personalizado para o seu objetivo',
  'paywallIntl.benefit2': 'Biblioteca de exercícios com demonstração em vídeo',
  'paywallIntl.benefit3': 'Registro de séries, repetições e pesos',
  'paywallIntl.benefit4': 'Acompanhamento da sua evolução',
  'paywallIntl.benefit5': 'Ajustes conforme o seu progresso',
  'paywallIntl.resultsTitle': 'Gente de verdade. Progresso de verdade.',
  'paywallIntl.resultsSubtitle': 'Veja como as pessoas estão treinando melhor e ganhando consistência com o FitClutch.',
  'paywallIntl.testimonial1_category': 'Emagrecimento',
  'paywallIntl.testimonial1_title': 'Marina T. — Retomou o controle aos 41',
  'paywallIntl.testimonial1_result': 'Resultado: -5,5 kg',
  'paywallIntl.testimonial1_quote': 'Finalmente consegui seguir um plano sem ficar trocando de treino toda semana.',
  'paywallIntl.testimonial2_category': 'Ganho de massa',
  'paywallIntl.testimonial2_title': 'Lucas R. — Reconstruiu a força aos 34',
  'paywallIntl.testimonial2_result': 'Resultado: +18% de força',
  'paywallIntl.testimonial2_quote': 'Passei a acompanhar minha progressão e finalmente comecei a perceber evolução.',
  'paywallIntl.testimonial3_category': 'Consistência',
  'paywallIntl.testimonial3_title': 'Sofia M. — Finalmente conseguiu manter',
  'paywallIntl.testimonial3_result': 'Resultado: 4 meses seguidos',
  'paywallIntl.testimonial3_quote': 'O plano cabe na minha rotina de verdade, então parei de pular treino.',
  'paywallIntl.testimonial4_category': 'Iniciante',
  'paywallIntl.testimonial4_title': 'Leo M. — Começou do zero aos 28',
  'paywallIntl.testimonial4_result': 'Resultado: 3 treinos por semana',
  'paywallIntl.testimonial4_quote': 'Eu nunca soube por onde começar. O plano me mostrou o que fazer em cada dia.',
  'paywallIntl.faqTitle': 'Perguntas Frequentes',
  'paywallIntl.faq1_q': 'Como acesso o FitClutch depois de assinar?',
  'paywallIntl.faq1_a': 'Na hora — seu plano libera assim que o pagamento é confirmado, sem espera.',
  'paywallIntl.faq2_q': 'Preciso de equipamento de academia?',
  'paywallIntl.faq2_a': 'Não. Seu plano é montado a partir das suas respostas, incluindo se você treina em casa, ao ar livre ou na academia.',
  'paywallIntl.faq3_q': 'O FitClutch serve pra iniciantes?',
  'paywallIntl.faq3_a': 'Sim. O plano se adapta ao seu nível atual, do iniciante completo ao avançado.',
  'paywallIntl.faq4_q': 'Como faço para cancelar?',
  'paywallIntl.faq4_a': 'Você pode cancelar a qualquer momento na sua página de conta, antes da próxima renovação. Sem ligação, sem pegadinha de retenção.',
  'paywallIntl.chooseTitle': 'Escolha seu plano',
  'paywallIntl.couponLabel': 'FITCLUTCH50',
  'paywallIntl.couponBadge': '50% OFF',
  'paywallIntl.couponActiveFor': 'Cupom promocional ativo por:',
  'paywallIntl.perDay': 'por dia',
  'paywallIntl.cta': 'Desbloquear meu plano',
  'paywallIntl.billingDisclosure': 'Sem cancelamento antes do fim do período promocional, eu aceito que o FitClutch cobre automaticamente {precoCheio} a cada {periodo} até eu cancelar. Cancele quando quiser na sua página de conta.',
  'paywallIntl.secureCheckout': 'Checkout 100% Seguro',
  'paywallIntl.guaranteeTitle': 'Garantia de 30 dias',
  'paywallIntl.guaranteeBody': 'Experimente o FitClutch com tranquilidade. Se a compra for elegível, você poderá solicitar o reembolso conforme os termos da nossa garantia.',

  // ---- Refatoração da paywall (05/10/2026): prévia real do plano + conversão
  'paywallIntl.myPlan': 'Meu Plano',
  'paywallIntl.dayTab': 'DIA {n}',
  'paywallIntl.workoutSettings': 'DIA {n} · CONFIGURAÇÃO DO TREINO',
  'paywallIntl.chipMinutes': '{n} min',
  'paywallIntl.chipMuscles': '{n} músculos',
  'paywallIntl.goal_condicionamento': 'Condicionamento',
  'paywallIntl.goal_forca': 'Força',
  'paywallIntl.goal_emagrecer': 'Emagrecimento',
  'paywallIntl.goal_hipertrofia': 'Hipertrofia',
  'paywallIntl.targetMuscles': 'MÚSCULOS-ALVO',
  'paywallIntl.exercisesCount': '{n} EXERCÍCIOS',
  'paywallIntl.edit': 'Editar',
  'paywallIntl.setsReps': '{sets} séries • {reps} reps',
  'paywallIntl.setsOnly': '{sets} séries',
  'paywallIntl.statLineWorkouts': 'treinos/semana',
  'paywallIntl.statLineMinutes': 'por treino',
  'paywallIntl.statLineKcal': 'kcal estimadas',
  'paywallIntl.unlockTitle': 'Seu plano completo está pronto.',
  'paywallIntl.unlockSub': 'Desbloqueie todos os dias, todos os exercícios e o acompanhamento do seu progresso.',
  'paywallIntl.unlockCta': 'DESBLOQUEAR MEU PLANO',
  'paywallIntl.benefit6': 'Treinos para academia ou casa, você escolhe',
  'paywallIntl.progressTitle': 'Mais que uma lista de exercícios',
  'paywallIntl.progressSub': 'Você desbloqueia um sistema para acompanhar cada treino e a sua evolução.',
  'paywallIntl.progressToday': 'SEU PLANO HOJE',
  'paywallIntl.progressNext': 'SEU PROGRESSO',
  'paywallIntl.progressNow': 'Consistência hoje',
  'paywallIntl.progressWith': 'Com o FitClutch',
  'paywallIntl.progressNote': 'Projeção baseada nas suas respostas.',
  'paywallIntl.track1': 'Histórico de treinos',
  'paywallIntl.track2': 'Evolução de cargas',
  'paywallIntl.track3': 'Equilíbrio muscular',
  'paywallIntl.track4': 'Fitness Score',
  'paywallIntl.convertTitle': 'Comece seu plano personalizado hoje',
  'paywallIntl.convertSub': 'Escolha como quer começar. Cancele quando quiser.',
  'paywallIntl.guaranteeNote': 'Experimente o FitClutch com tranquilidade. Consulte os termos da garantia.',
  'paywallIntl.stickyText': 'Seu plano está pronto',
  'paywallIntl.stickyCta': 'Desbloquear',
  'paywallIntl.plan_week': 'Plano Semanal',
  'paywallIntl.plan_month': 'Plano Mensal',
  'paywallIntl.plan_year': 'Plano Anual',
  'paywallIntl.badgePopular': 'MAIS POPULAR',
  'paywallIntl.badgeBest': 'MELHOR VALOR',
  'paywallIntl.badgeOff': '{pct}% OFF',
  'paywallIntl.perWeekShort': '/ semana',
  'paywallIntl.perMonthShort': '/ mês',
  'paywallIntl.perYearShort': '/ ano',
  'paywallIntl.perDayEq': '{price} por dia',
  'paywallIntl.renewal': 'Você paga {promo} hoje. Depois, o FitClutch renova automaticamente por {full} a cada {period} até você cancelar. Cancele quando quiser na sua página de conta, antes da próxima renovação.',
  'paywallIntl.renewalNoPromo': 'O FitClutch renova automaticamente por {full} a cada {period} até você cancelar. Cancele quando quiser na sua página de conta, antes da próxima renovação.',
  'paywallIntl.period_week': 'semana',
  'paywallIntl.period_month': 'mês',
  'paywallIntl.period_year': 'ano',
  'paywallIntl.benefitsEmoji1': 'Plano personalizado a partir das suas respostas',
  'paywallIntl.faq5_q': 'Existe garantia?',
  'paywallIntl.faq5_a': 'Sim. O FitClutch tem garantia de 30 dias. Se a compra for elegível, você poderá solicitar o reembolso conforme os termos da nossa garantia.',
  'paywallIntl.faq6_q': 'Posso treinar em casa?',
  'paywallIntl.faq6_a': 'Sim. Seu plano é montado a partir das suas respostas, inclusive se você treina em casa ou na academia.',
  'paywallIntl.placeholderTag': 'Exemplo',
  'paywallIntl.resultsDisclaimer': 'Exemplos ilustrativos. Os resultados individuais variam.',
  'paywallIntl.plansLoading': 'Carregando planos…',
  'paywallIntl.plansError': 'Não foi possível carregar os planos agora.',
  'paywallIntl.plansRetry': 'Tentar novamente',
  'paywallIntl.guaranteeSectionTitle': 'Garantia de 30 dias',
  'paywallIntl.guaranteeSectionBody': 'Experimente o FitClutch com tranquilidade. Se a compra for elegível, você poderá solicitar o reembolso conforme os termos da nossa garantia.',
  'paywallIntl.secureTitle': 'Checkout 100% Seguro',
  'paywallIntl.secureNote': 'Pagamento processado pelo Stripe. Nós nunca vemos os dados do seu cartão.',
  'paywallIntl.finalTitle': 'Seu plano está esperando',
  'paywallIntl.finalSub': 'Comece hoje e treine com um plano feito para você.',
};
